import {HubConnection} from '@microsoft/signalr';
import {Appointment} from '../../../../appointment/data/appointment';
import {SignalRService} from '../signal-r.service';
import {EventEmitter} from '@angular/core';

export class AppointmentSRHandler {
  static instance: AppointmentSRHandler;
  connection: HubConnection;

  onReceive: EventEmitter<Appointment> = new EventEmitter<Appointment>();

  constructor(public signalRService: SignalRService) {
    this.signalRService = signalRService;
    AppointmentSRHandler.instance = this;
  }

  async hook(connection: HubConnection): Promise<void> {
    this.connection = connection;
    this.connection.on('appointmentSR', this.triggerAppointmentReceive);
  }

  triggerAppointmentReceive(appointments: Appointment): void {
    AppointmentSRHandler.instance.onReceive.emit(appointments);
  }
}

